/*
 * ******************************************************************
 * Copyright (c) 2021-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Event } from "@app/services/dispatcher/events/event";
import { TaskV2 } from "@api/generated/vcdr";

export class OperationInitEvent extends Event {
    public static ID: string = "OPERATION_INITIATED";

    constructor(public type: OperationInitType,
                public submitted: number = 0,
                public failedToSubmit: number = 0,
                public tasks: TaskV2[] = []) {
        super(OperationInitEvent.ID);
    }
}

export class OperationCompletedEvent extends Event {
    public static ID: string = "OPERATION_COMPLETE";

    constructor(public task: TaskV2,
                public isNew: boolean = true,
                public eventTitle?: string) {
        super(OperationCompletedEvent.ID);
    }
}

/**
 * OperationInitEvent types.
 */
export class OperationInitType {
    public static readonly RESUME: string = "RESUME";
    public static readonly ACTIVATE: string = "ACTIVATE";
    public static readonly REFRESH: string = "REFRESH";
    public static readonly DEACTIVATE: string = "DEACTIVATE";
    public static readonly REQUEST_ACCESS: string = "REQUEST-ACCESS";
    public static readonly START_BILLING: string = "START-BILLING";
    public static readonly UPGRADE: string = "UPGRADE";
}
